import React, { useState, useEffect, useCallback } from 'react';
import moment from 'moment';
import DashboardLayout from 'layout/dashboardLayout';
import { useSelector, useDispatch } from 'react-redux';
import Status from 'components/common/status';
import { useHistory } from 'react-router-dom';
import { fetchTerminalRequests, fetchTerminals } from 'store/actions/terminal';
import TerminalLog from './components/TerminalLog';
import styles from './terminal.module.scss';
import Button from '../../components/button';
import TerminalRequestLog from './components/TerminalRequestLog';

const Terminal = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const [page, setPage] = useState(0);
  const [listingPage, setListingPage] = useState(0);
  const [status, setStatus] = useState('All');

  const handleOnRequestTerminal = () => {
    history.push('/terminal/order');
  };

  const { merchantId } = useSelector((state) => state.common.user);

  const getTerminals = useCallback(
    (params) => {
      dispatch(fetchTerminals(params));
    },
    [dispatch],
  );

  const getTerminalRequests = useCallback(
    (params) => {
      dispatch(fetchTerminalRequests(params));
    },
    [dispatch],
  );

  useEffect(() => {
    const params = {
      merchantId,
    };

    if (status === 'Requests') {
      getTerminalRequests(params);
    } else {
      getTerminals(params);
    }
  }, [status]);

  const { terminals, terminalRequests } = useSelector(
    (state) => state.terminal,
  );

  const { data: terminalData, pagination, inProgress } = terminals;
  const {
    data: terminalRequestData,
    pagination: requestPagination,
    inProgress: requestProgress,
  } = terminalRequests;

  const handleRequestPagination = (data) => {
    setListingPage(data.selected + 1);
    getTerminalRequests({ ...requestPagination, page: data.selected });
  };

  const handleTerminalPagination = (data) => {
    setPage(data.selected + 1);
    getTerminals({ ...pagination, page: data.selected });
  };

  return (
    <DashboardLayout>
      <div className={styles.terminal}>
        <div className={styles.terminalTop}>
          <div className={styles.terminalTopLeft}>
            <div className={styles.status} data-testid="status">
              <Status
                altStatuses={['Assigned', 'Requests']}
                selectActive="Assigned"
                variant="blue"
                handleClick={(item) => setStatus(item)}
              />
            </div>
          </div>

          <Button
            onClick={handleOnRequestTerminal}
            className={styles.requestBtn}
            text="Request Terminal"
            variant="primary"
          />
        </div>
      </div>
      {status === 'Requests' ? (
        <TerminalRequestLog
          inProgress={requestProgress}
          page={listingPage}
          meta={requestPagination}
          data={terminalRequestData}
          handleRequestPagination={handleRequestPagination}
        />
      ) : (
        <TerminalLog
          inProgress={inProgress}
          page={page}
          data={terminalData}
          meta={pagination}
          handleTerminalPagination={handleTerminalPagination}
        />
      )}
    </DashboardLayout>
  );
};

export default Terminal;
